import { createThunkRequest, DELETE, GET, PATCH, POST, PUT } from '@webapp/account/src/libs/request';

export const getUserWalletBalance = createThunkRequest(
    'respondents/getUserWalletBalance',
    async () => {
        const { balance } = await GET('user/wallet_balance');

        return balance;
    },
    { notify: false },
);

export const getDataPoints = createThunkRequest(
    'respondents/getDataPoints',
    async () => {
        const { categories, dataPoints } = await GET('get/data_points');

        return { categories, dataPoints };
    },
    { notify: false },
);

export const getCampaignList = createThunkRequest(
    'respondents/getCampaignList',
    async ({ surveyId }: { surveyId: number }) => {
        const { campaigns } = await GET('get/survey_campaigns', { surveyId });

        return campaigns;
    },
    { notify: false },
);

export const getCampaignCost = createThunkRequest(
    'respondents/getCampaignCost',
    async ({ campaignId }: { campaignId: number }) => {
        const { campaignCoast } = await GET('get/campaign_cost', { campaignId });

        return { campaignCoast };
    },
    { notify: false },
);

export const postAddEnjoypanelCampaign = createThunkRequest(
    'respondents/addEnjoypanelCampaign',
    async (data: {
        title: string;
        surveyId: number;
        totalQuota: number;
        categories: Array<number>;
        startAt: string;
        endAt: string;
    }) => {
        const { id } = await POST('add/enjoypanel_campaign', data);

        return { id };
    },
);

export const patchChangeEnjoypanelCampaign = createThunkRequest(
    'respondents/changeEnjoypanelCampaign',
    (data: { campaignId: number; totalQuota: number; categories: Array<number>; startAt: string; endAt: string }) => {
        return PATCH('change/enjoypanel_campaign', data);
    },
);

export const postStartEnjoypanelCampaign = createThunkRequest(
    'respondents/startEnjoypanelCampaign',
    async ({ campaignId }: { campaignId: number }) => {
        const data = await POST('start/enjoypanel_campaign', { campaignId });

        return data;
    },
);

export const getQuotaTables = createThunkRequest(
    'respondents/getQuotaTables',
    ({ campaignId }: { campaignId: number }) => {
        return GET('get/quota_tables', { campaignId });
    },
    { notify: false },
);

export const putAddQuotaTables = createThunkRequest(
    'respondents/addQuotaTables',
    (data: { campaignId: number; quotas: Array<Record<string, any>>; count: number }) => {
        return PUT('add/quota_tables', data);
    },
);

export const deleteCampaign = createThunkRequest(
    'respondents/deleteCampaign',
    async ({ campaignId }: { campaignId: number }) => {
        await DELETE(`delete/campaign/${campaignId}`);

        return { campaignId };
    },
);

export const changeCampaignTitle = createThunkRequest(
    'respondents/changeCampaignTitle',
    async (data: { campaignId: number; title: string }) => {
        await PATCH(`change/campaign_title`, data);

        return data;
    },
);
